import { STATUS_LABEL, type IssueStatus } from './types.ts';

const TONE: Record<IssueStatus, string> = {
  SUBMITTED: 'text-primary',
  ASSIGNED: 'text-[hsl(var(--tertiary))]',
  IN_PROGRESS: 'text-[hsl(var(--warning))]',
  RESOLVED: 'text-[hsl(var(--success))]',
  CLOSED: 'text-muted-foreground',
};

/** Outlined pill, coloured text — status is a label, not a pressable thing, so no fill. */
export function StatusChip({ status }: { status: IssueStatus }): JSX.Element {
  return (
    <span
      className={`inline-flex shrink-0 items-center whitespace-nowrap rounded-full border border-[hsl(var(--border-strong))] px-2.5 py-0.5 text-xs font-medium ${TONE[status]}`}
    >
      {STATUS_LABEL[status]}
    </span>
  );
}
